import { render, staticRenderFns } from "./InfoRounded.vue?vue&type=template&id=b90b6460&"
import script from "./InfoRounded.vue?vue&type=script&lang=js&"
export * from "./InfoRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports